<template>
  <v-btn color="primary lighten-2"
         small
         icon
         :disabled="requestState === 'Loading'"
         :loading="requestState === 'Loading'"
         @click="handleClickExport">
    <v-icon small>fas fa-file-excel</v-icon>
  </v-btn>
</template>

<script>
  import FileSaver from 'file-saver'
  import {RequestState} from '../../../requestState'
  import {invoiceService, notificationService} from '../../../application'
  import {extractFileName} from '../../../helpers/file'

  export default {
    name: 'export-invoice-as-excel',
    props: {
      invoiceId: {
        type: Number,
        required: false,
      },
      clientId: {
        type: String,
        required: false,
      },
      costCenterId: {
        type: String,
        required: false,
      },
      regionId: {
        type: String,
        required: false,
      },
      shortVersion: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        requestState: RequestState.NotPerformed
      }
    },
    methods: {
      async handleClickExport() {
        if (this.requestState === RequestState.Loading) {
          return
        }

        this.requestState = RequestState.Loading;

        try {
          let data

          // Created by costCenter && regionId
          if (this.clientId !== '00000000-0000-0000-0000-000000000000') {
            data = await invoiceService.exportInvoiceToExcel({
              invoiceId: this.invoiceId,
              shortVersion: this.shortVersion,
            })
          } else {
            data = await invoiceService.exportCostCenterInvoiceToExcel({
              regionalInvoiceId: this.invoiceId,
              shortVersion: this.shortVersion,
            })
          }

          const csv = data.data;
          const fileName = extractFileName(data);
          const blob = new Blob([csv], {type: ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          FileSaver.saveAs(blob, fileName);
          this.requestState = RequestState.Success;
        } catch (error) {
          notificationService.error('Can\'t perform operation');
          console.error('Error acurred in handleClickExport', error);
          this.requestState = RequestState.Failed;
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/ExportInvoiceAsExcel.vue